module.exports = __webpack_public_path__ + "static/img/11.b12aa86d.png";